import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import MutasiBarangDetailTabBarangLain from "./mutasiBarangDetailTabBarangLain";
import MutasiBarangDetailTabHadiah from "./mutasiBarangDetailTabHadiah";
import MutasiBarangDetailTabKSU from "./mutasiBarangDetailTabKSU";
import MutasiBarangDetailTabUnit from "./mutasiBarangDetailTabUnit";

class MutasiBarangDetailTabs extends Component {
  render() {
    return (
      <Tabs>
        <TabList>
          <Tab>Unit</Tab>
          <Tab>KSU</Tab>
          <Tab>Hadiah</Tab>
          <Tab>Barang Lain</Tab>
        </TabList>
        <TabPanel>
          <MutasiBarangDetailTabUnit
            state={this.props.state}
            buttonType={this.props.buttonType}
            onSetState={this.props.onSetState}
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
        <TabPanel>
          <MutasiBarangDetailTabKSU
            state={this.props.state}
            buttonType={this.props.buttonType}
            onSetState={this.props.onSetState}
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
        <TabPanel>
          <MutasiBarangDetailTabHadiah
            state={this.props.state}
            buttonType={this.props.buttonType}
            onSetState={this.props.onSetState}
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
        <TabPanel>
          <MutasiBarangDetailTabBarangLain
            state={this.props.state}
            buttonType={this.props.buttonType}
            onSetState={this.props.onSetState}
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
      </Tabs>
    );
  }
}

export default MutasiBarangDetailTabs;
